import React, { useState } from 'react';
import {
  Box,
  Paper,
  TextField,
  Button,
  MenuItem,
  Stack,
  Snackbar,
  Alert,
  Typography
} from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { feedbackApi, type Feedback } from '../services/api';
import PageHeader from '../components/PageHeader';

const FeedbackForm: React.FC = () => {
  const [form, setForm] = useState<{ title: string; content: string; category: Feedback['category']; contact: string }>({ title: '', content: '', category: 'USAGE', contact: '' });
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' as 'success' | 'error' });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.title.trim() || !form.content.trim()) {
      setSnackbar({ open: true, message: '请填写标题和内容', severity: 'error' });
      return;
    }
    setLoading(true);
    try {
      await feedbackApi.submit(form);
      setSnackbar({ open: true, message: '反馈提交成功，我们将尽快处理', severity: 'success' });
      setForm({ title: '', content: '', category: 'USAGE', contact: '' });
    } catch (err: any) {
      setSnackbar({ open: true, message: err?.response?.data?.message || '提交失败', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <PageHeader title="客户反馈" subtitle="提交产品建议、缺陷或使用咨询" />

      <Paper component="form" onSubmit={handleSubmit} sx={{ p: 4, borderRadius: 2, maxWidth: 720, mx: 'auto' }}>
        <Stack spacing={3}>
          <TextField
            label="标题"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            fullWidth
            required
          />
          <TextField
            select
            label="反馈分类"
            value={form.category}
            onChange={(e) => setForm({ ...form, category: e.target.value as Feedback['category'] })}
            fullWidth
          >
            <MenuItem value="USAGE">使用咨询</MenuItem>
            <MenuItem value="BUG">缺陷</MenuItem>
            <MenuItem value="FEATURE">功能建议</MenuItem>
            <MenuItem value="OTHER">其他</MenuItem>
          </TextField>
          <TextField
            label="详细描述"
            value={form.content}
            onChange={(e) => setForm({ ...form, content: e.target.value })}
            fullWidth
            multiline
            rows={5}
            required
          />
          <TextField
            label="联系方式（可选）"
            value={form.contact}
            onChange={(e) => setForm({ ...form, contact: e.target.value })}
            fullWidth
            placeholder="邮箱 / 手机号"
          />
          <Button
            type="submit"
            variant="contained"
            size="large"
            startIcon={<SendIcon />}
            disabled={loading}
          >
            {loading ? '提交中...' : '提交反馈'}
          </Button>
        </Stack>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default FeedbackForm;
